import preparedReducer from './reducer';
import { requestAddress, updateAddress } from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'addresses';

export const selectors = (state) => state[SLICE_NAME];

export const selectAddress =
  ({ tableName, entityID }) =>
  (state) =>
    state[SLICE_NAME]?.[tableName]?.[entityID] || {};

export const actions = {
  requestAddress,
  updateAddress,
};
